export default __webpack_public_path__ + "80fd56635585a90bfc9be80cd14e92a2.svg";